import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-black/90 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="text-2xl font-bold bg-gradient-to-r from-blue-400 via-blue-300 to-cyan-300 bg-clip-text text-transparent hover:from-blue-300 hover:via-blue-200 hover:to-cyan-200 transition-all duration-300"
          >
            Laura Sommerfeld
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-200 hover:text-blue-300 transition-colors duration-200 text-sm font-medium uppercase tracking-wider"
            >
              Über mich
            </button>
            <button
              onClick={() => scrollToSection('video')}
              className="text-gray-200 hover:text-blue-300 transition-colors duration-200 text-sm font-medium uppercase tracking-wider"
            >
              Video
            </button>
            <button
              onClick={() => scrollToSection('music')}
              className="text-gray-200 hover:text-blue-300 transition-colors duration-200 text-sm font-medium uppercase tracking-wider"
            >
              Musik
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-blue-500 to-cyan-400 text-white px-6 py-2 rounded-full hover:from-blue-600 hover:to-cyan-500 transition-all duration-300 text-sm font-medium uppercase tracking-wider shadow-lg hover:shadow-blue-500/50"
            >
              Kontakt
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden bg-black/95 backdrop-blur-md py-4 space-y-4">
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-gray-200 hover:text-blue-300 hover:bg-white/5 transition-colors duration-200 text-sm font-medium uppercase tracking-wider"
            >
              Über mich
            </button>
            <button
              onClick={() => scrollToSection('video')}
              className="block w-full text-left px-4 py-2 text-gray-200 hover:text-blue-300 hover:bg-white/5 transition-colors duration-200 text-sm font-medium uppercase tracking-wider"
            >
              Video
            </button>
            <button
              onClick={() => scrollToSection('music')}
              className="block w-full text-left px-4 py-2 text-gray-200 hover:text-blue-300 hover:bg-white/5 transition-colors duration-200 text-sm font-medium uppercase tracking-wider"
            >
              Musik
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-blue-400 hover:text-blue-300 hover:bg-white/5 transition-colors duration-200 text-sm font-medium uppercase tracking-wider"
            >
              Kontakt
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
